import { Box, Grid, Rating, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTS from "../../globals/common_utilities/constant";
import moment from "moment";
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeedBackGrid from "../FeedBackGrid";
import "./feedBackListing.scss";
import FeedBackFilter from "../FeedBackFilter";
import ToggleButton from "../ToggleButton";
import { API, ROLE, STATUS, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Loading from "../loader";
import Pagination from "@mui/material/Pagination";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import Cookies from "universal-cookie";
import NoDataFound from "../NoDataFound/NoDataFound";
import DateRangePicker from "../TP_DateRangePicker";
import Dropdown from "../../components/TP_Dropdown";
import Button from "../common/Button";
import { hideFilter } from "../../redux/features/trainingCenter";

const FeedBackListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hideFilterData = useSelector(
    (state) => state?.trainingCenterDetails?.showFilterFB
  );
  const { AllPageFilter } = useSelector((state) => state);
  const [studentFeedbackList, setStudentFeedbackList] = useState();
  const [instructorList, setInstructorList] = useState();
  const [trainingList, setTrainingList] = useState();
  const [gridView, setGridView] = useState(false);
  const [count, setCount] = useState();
  const [isloading, setIsloading] = useState(false);
  const [pageCount, setPageCount] = useState();
  const [offset, setOffset] = useState(0);
  const limit = 12;

  const filterBody = [
    offset,
    AllPageFilter?.FeedbackFilter?.trainingName,
    AllPageFilter?.FeedbackFilter?.instructor,
    AllPageFilter?.FeedbackFilter?.name,
    AllPageFilter?.FeedbackFilter?.startDate,
    AllPageFilter?.FeedbackFilter?.endDate,
  ];
  const { loginResponse, loading, error } = useSelector((state) => {
    console.log("state-------->>>", state);
    return state.login;
  });
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");

  const [studentQueryParam, setstudentQueryParam] = useState({
    limit: limit || 12,
    offset: 0,
  });
  const toggleFunction = () => {
    setGridView(!gridView);
  };

  const gotoFeedBAckChart = ({ array_1, array_2 }) => {
    navigate(APP_ROUTES.FEEDBACK_CHART, {
      state: {
        array_1: array_1,
        array_2: array_2,
      },
    });
  };

  const setInstructorListing = async () => {
    // `${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN+API.END_POINTS.USERS}`,
    let instructorResponse = "";
    if (role_code === ROLE.ADMIN || role_code === ROLE.INSTRUCTOR) {
      const queryParam = {
        is_active: true,
        role_id: 3,
        id: id,
      };
      instructorResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.USERS
        }`,
        // CONSTANTS.API.INSTRUCTOR,
        queryParam
      );
    } else if (role_code === ROLE.STUDIO_ADMIN) {
      const queryParam = {
        is_active: true,
        role_id: 3,
        studio_id: studio_id,
      };
      instructorResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.STUD_ADMIN
        }`,
        // CONSTANTS.API.INSTRUCTOR_STUDIO_ADMIN,
        queryParam
      );
    }
    if (instructorResponse.status === STATUS.OK) {
      const instructorVal = instructorResponse.data.data.rows.map((value) => ({
        id: value.id,
        value: value.id,
        label: value.name,
      }));
      setInstructorList(instructorVal);
    } else if (instructorResponse.status === STATUS.DATA_NOT_FOUND) {
      setInstructorList([]);
    } else {
    }
  };
  const setTraininglisting = async () => {
    let instructor_id = id;
    if (role_code === ROLE.STUDIO_ADMIN) {
      const locationResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.FEEDBACK_TRAINING
        }`,
        // CONSTANTS.API.FEEDBACK_TRAINING,
        { studio_id }
      );
      if (locationResponse.status === STATUS.OK) {
        let locationVal = locationResponse.data.data.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.title,
        }));
        setTrainingList(locationVal);
      } else if (locationResponse.status === STATUS.DATA_NOT_FOUND) {
        setTrainingList([]);
      } else {
      }
    } else if (role_code === ROLE.INSTRUCTOR) {
      const locationResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.FEEDBACK_TRAINING
        }`,
        // CONSTANTS.API.FEEDBACK_TRAINING,
        { instructor_id }
      );
      if (locationResponse.status === STATUS.OK) {
        let locationVal = locationResponse.data.data.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.title,
        }));
        setTrainingList(locationVal);
      } else if (locationResponse.status === STATUS.DATA_NOT_FOUND) {
        setTrainingList([]);
      } else {
      }
    } else {
      const locationResponse = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
          API.END_POINTS.FEEDBACK_TRAINING
        }`
        // CONSTANTS.API.FEEDBACK_TRAINING,
      );
      if (locationResponse.status === STATUS.OK) {
        let locationVal = locationResponse.data.data.map((value) => ({
          id: value.id,
          value: value.id,
          label: value.title,
        }));
        setTrainingList(locationVal);
      } else if (locationResponse.status === STATUS.DATA_NOT_FOUND) {
        setTrainingList({});
      } else {
      }
    }
  };

  const onPageClickhandler = (e, data) => {
    setstudentQueryParam((prevState) => ({
      ...prevState,
      offset: Math.ceil((data - 1) * limit),
    }));
    // setOffset(Math.ceil((data - 1) * limit));
    window.scrollTo(0, 0);
  };

  const loadStudentData = async (filter) => {
    setIsloading(true);
    console.log("filter---------->>", filter);
    let queryParam = {};
    Object.assign(queryParam, studentQueryParam);
    // let queryParam = {
    // 	limit: limit,
    // 	offset: offset,
    // };
    console.log("check query param", queryParam);
    let from = moment().subtract(7, "days").format("YYYY-MM-DD");
    let end = moment().format("YYYY-MM-DD");
    if (role_code === ROLE.INSTRUCTOR) {
      queryParam.instructor_id = id;

      if (filter?.name !== "" && filter?.name !== undefined) {
        queryParam.search_term = filter?.name.trim();
      }

      let response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
          API.END_POINTS.GET_FEEDBACK_INSTRUCTOR
        }`,
        // CONSTANTS.API.GET_FEEDBACK_INSTRUCTOR,
        queryParam
      );
      if (response.status === STATUS.OK) {
        setIsloading(false);
        console.log("set::::::::::::", response.data.data.rows);
        setStudentFeedbackList(response.data.data.rows);
        setPageCount(() => Math.ceil(response.data.data.count / limit));
        setCount(response.data.data.count);
      } else if (response.status === STATUS.DATA_NOT_FOUND) {
        setIsloading(false);
        setStudentFeedbackList([]);
        setCount(0);
        setPageCount(0);
      } else {
        setIsloading(false);
      }
    } else if (role_code === ROLE.ADMIN) {
      if (filter?.name !== "" && filter?.name !== undefined) {
        queryParam.search_term = filter?.name.trim();
      }
      let response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
          API.END_POINTS.GET_FEEDBACK_LIST
        }`,
        // CONSTANTS.API.GET_FEEDBACK_LIST,
        queryParam
      );
      if (response.status === STATUS.OK) {
        setIsloading(false);
        setStudentFeedbackList(response.data.data.rows);
        console.log("set::::::::::::", response.data.data.rows);

        setPageCount(() => Math.ceil(response.data.data.count / limit));
        setCount(response.data.data.count);
      } else if (response.status === STATUS.DATA_NOT_FOUND) {
        setIsloading(false);
        setStudentFeedbackList([]);
        setCount(0);
        setPageCount(0);
      } else {
        setIsloading(false);
      }
    } else if (role_code === ROLE.STUDIO_ADMIN) {
      queryParam.studio_id = studio_id;

      if (filter?.name !== "" && filter?.name !== undefined) {
        queryParam.search_term = filter?.name.trim();
      }
      let response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
          API.END_POINTS.GET_FEEDBACK_LIST
        }`,
        // CONSTANTS.API.GET_FEEDBACK_LIST,
        queryParam
      );
      if (response.status === STATUS.OK) {
        setIsloading(false);
        setStudentFeedbackList(response.data.data.rows);
        console.log("set::::::::::::", response.data.data.rows);
        setPageCount(() => Math.ceil(response.data.data.count / limit));

        setCount(response.data.data.count);
      } else if (response.status === STATUS.DATA_NOT_FOUND) {
        setIsloading(false);
        setStudentFeedbackList([]);
        setCount(0);
        setPageCount(0);
      } else {
        setIsloading(false);
      }
    }
    // });
  };

  const [showFilter, setShowFilter] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [allTC, setAllTC] = useState([]);

  // const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  let userID = loginData?.id;
  let userRole = loginData?.role_code;
  let userStudioID = loginData?.studio_id;

  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
    let params = {};
    Object.assign(params, studentQueryParam);
    console.log("startDate", startDate);
    console.log("endDate", endDate);
    range[0]
      ? (params.from_date = `${moment(startDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    range[1]
      ? (params.end_date = `${moment(endDate).format("YYYY-MM-DD")}`)
      : delete params.end_date;
    setstudentQueryParam({ ...params });
    console.log("datefilter", studentQueryParam);
  };

  let uniqueName = [
    //...new Map(studioName?.map((item) => [item['value'], item])).values(),
  ];
  const filterShow = () => {
    setShowFilter(!showFilter);
    setFilterCount(filterCount + 1);
    dispatch(hideFilter(showFilter));
  };
  const dropdownSelectInstructor = (StudioName) => {
    console.log("searchStudio", StudioName);
    let params = {};
    Object.assign(params, studentQueryParam);
    StudioName?.value
      ? (params.instructor_id = `${StudioName?.value}`)
      : delete params.instructor_id;
    params.offset = 0;
    setstudentQueryParam({ ...params });
  };
  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string?.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  };
  const dropdownSelectTC = (getName) => {
    console.log("trainingCenter", getName);
    let params = {};
    Object.assign(params, studentQueryParam);
    getName?.id ? (params.tid = `${getName?.id}`) : delete params.tid;
    console.log("params", params);
    setstudentQueryParam({ ...params });
  };

  const clearButton = () => {
    if (userRole == "SUPER_ADMIN") {
      document.getElementById("TCFeedbackFilter").click();
    }
    document.getElementById("InstructorFeedbackFilter").click();
    document.getElementById("FeedBackCLearDate").click();
    document.getElementById("clearFilterSF").click();
    setShowFilter(!showFilter);
  };
  const nameFilter = async (name) => {
    let filter = {
      trainingName: AllPageFilter?.FeedbackFilter?.trainingName,
      instructor: AllPageFilter?.FeedbackFilter?.instructor,
      name: name,
      startDate: AllPageFilter?.FeedbackFilter?.startDate,
      endDate: AllPageFilter?.FeedbackFilter?.endDate,
    };
    console.log("chek the filter----", filter);
    await loadStudentData(filter);
  };
  useEffect(() => {
    if (role_code === "INSTRUCTOR") {
      loadStudentData();
      setTraininglisting();
    } else {
      loadStudentData();
      setInstructorListing();
      setTraininglisting();
    }
  }, [studentQueryParam]);
  useEffect(() => {
    loadStudentData();
    // setInstructorListing();
    // setTraininglisting();
  }, [studentQueryParam?.offset]);

  useEffect(() => {
    let filter = {
      trainingName: AllPageFilter?.FeedbackFilter?.trainingName,
      instructor: AllPageFilter?.FeedbackFilter?.instructor,
      name: AllPageFilter?.FeedbackFilter?.name,
      startDate: AllPageFilter?.FeedbackFilter?.startDate,
      endDate: AllPageFilter?.FeedbackFilter?.endDate,
    };
    loadStudentData(filter);
  }, filterBody);

  return (
    <>
      {console.log("pageCount------------>>", pageCount)}
      <Box className='feedBack_page'>
        <div className='scrollContainer'>
          <FeedBackFilter
            toggleFunction={toggleFunction}
            trainingList={trainingList}
            instructorList={instructorList}
            filterShow={() => filterShow()}
            nameFilter={(value) => nameFilter(value)}
          />
          {showFilter ? (
            <div className='feedbackFilterShow'>
              <Stack
                direction='row'
                className='lowerFilterContain'
                justifyContent={"space-around"}
                marginTop='1%'
                padding='5px'
              >
                <Grid container>
                  <Grid item flexGrow={0.2} xs={12} sm={12} md={5} lg={4}>
                    <DateRangePicker
                      getdateRange={datefilter}
                      clearID={"FeedBackCLearDate"}
                    />
                  </Grid>
                  {userRole === "SUPER_ADMIN" || userRole === "STUDIO_ADMIN" ? (
                    <Grid item flexGrow={0.2} xs={6} sm={6} md={2} lg={3}>
                      <Dropdown
                        clearable
                        // value={options[0]}
                        selection
                        options={instructorList}
                        placeholder='Instructors'
                        selectDropDown={dropdownSelectInstructor}
                        clearID={"InstructorFeedbackFilter"}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {userRole === "SUPER_ADMIN" ? (
                    <Grid
                      item
                      flexGrow={0.3}
                      xs={6}
                      sm={6}
                      md={3}
                      lg={3}
                      //marginTop={{ xs: '1%', sm: '1%', md: '2%' }}
                    >
                      <Dropdown
                        clearable
                        placeholder='Training'
                        options={trainingList}
                        selectDropDown={dropdownSelectTC}
                        clearID={"TCFeedbackFilter"}
                        sx={{
                          borderRight: "2px solid #2C2C2C ",
                          height: "40px",
                        }}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {userRole === "INSTRUCTOR" ? (
                    ""
                  ) : (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={2}
                      lg={2}
                      className='marginTopInstrut'
                    >
                      <Button
                        className='fs-4'
                        value='Clear Filter'
                        role='clearFilter'
                        onClick={() => {
                          clearButton();
                        }}
                      >
                        Clear Filter
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Stack>
            </div>
          ) : (
            ""
          )}
          {studentFeedbackList?.length > 0 ? (
            <Box className='FeedBack_listing_container'>
              {!gridView ? (
                isloading ? (
                  <MultiLine_Spinner />
                ) : (
                  <Grid container direction='column' rowSpacing={0}>
                    {studentFeedbackList &&
                      studentFeedbackList.map((array_1) => {
                        return array_1.users_trainings.map((array_2, i) => (
                          <>
                            <Grid item key={array_1?.id}>
                              <Box className='FeedBack_listing'>
                                <Box className='FeedBack_listing_upper'>
                                  <Grid
                                    container
                                    direction='row'
                                    justifyContent='left'
                                    alignItems='center'
                                  >
                                    {/* <Box className="item1">
                                    <input type="checkbox" />
                                  </Box> */}
                                    <Box className='item2'>
                                      {/* <span className="medium_f"> */}
                                      <span className='fs-4'>
                                        Training Name -
                                      </span>
                                      <span className='fs-3'>
                                        {array_1?.title.length > 25
                                          ? `${array_1?.title?.slice(0, 25)}...`
                                          : array_1?.title}
                                      </span>
                                    </Box>
                                    <Box className='item2'>
                                      <span className='fs-4'>
                                        {moment(array_1?.created_at).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </span>
                                    </Box>
                                    <Box className='item2'>
                                      <span className='fs-4'>Instructor -</span>
                                      <span className='fs-3'>
                                        {add3Dots(array_1?.user?.name, 10)}
                                        {/* {array_1?.user?.name.length > 15
                                          ? `${array_1?.user?.name?.slice(
                                              0,
                                              15
                                            )}...`
                                          : array_1?.user?.name} */}
                                        {/* {array_1.user?.name} */}
                                      </span>
                                    </Box>

                                    <Box className='item3'>
                                      <span className='fs-5 locationText'>
                                        {array_1?.region_training?.region_name
                                          .length > 25
                                          ? `${array_1?.region_training?.region_name.slice(
                                              0,
                                              25
                                            )}...`
                                          : array_1?.region_training
                                              ?.region_name}
                                        {/* {array_1?.region_training?.region_name} */}
                                      </span>
                                    </Box>
                                  </Grid>
                                </Box>
                                <Grid
                                  className='FeedBack_listing_lower'
                                  container
                                  direction='row'
                                  justifyContent='space-evenly'
                                  width={"100%"}
                                >
                                  <Stack direction={"row"} width='100%'>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                      <Box className='item1'>
                                        <span className='fs-4'>
                                          Total Student :
                                        </span>
                                        <span className='fs-3'>
                                          {array_2?.total_student_count}
                                        </span>
                                      </Box>
                                    </Grid>
                                    <Grid
                                      className='item2'
                                      item
                                      xs={12}
                                      sm={12}
                                      md={4}
                                      lg={4}
                                    >
                                      <Grid
                                        container
                                        direction='row'
                                        justifyContent='center'
                                        alignItems='center'
                                      >
                                        <span className='fs-4'> Rating :</span>
                                        <Stack>
                                          <Rating
                                            name='size-medium'
                                            defaultValue={
                                              array_1?.training_rating
                                                ? array_1?.training_rating
                                                : 0
                                            }
                                            precision={0.1}
                                            readOnly
                                          />
                                        </Stack>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={4}
                                      lg={4}
                                      display='flex'
                                      justifyContent={"center"}
                                      alignItems='center'
                                    >
                                      <Box className='item3'>
                                        <button
                                          className='view_feedback medium_f fs-4'
                                          onClick={() =>
                                            gotoFeedBAckChart({
                                              array_1,
                                              array_2,
                                            })
                                          }
                                        >
                                          View Feedback
                                        </button>
                                      </Box>
                                    </Grid>
                                  </Stack>
                                </Grid>
                              </Box>
                            </Grid>
                          </>
                        ));
                      })}
                  </Grid>
                )
              ) : isloading ? (
                <MultiLine_Spinner />
              ) : (
                <Grid container rowSpacing={1} columnSpacing={1}>
                  {studentFeedbackList &&
                    studentFeedbackList.map((array_1) => {
                      return array_1.users_trainings.map((array_2, i) => (
                        <>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={4}
                            key={array_1?.id}
                          >
                            <FeedBackGrid
                              array_1={array_1}
                              array_2={array_2}
                              gotoFeedBAckChart={gotoFeedBAckChart}
                            />
                          </Grid>
                        </>
                      ));
                    })}
                </Grid>
              )}
            </Box>
          ) : (
            <div>{!isloading && <NoDataFound />}</div>
          )}
          {isloading && <MultiLine_Spinner />}
        </div>
      </Box>
      {studentFeedbackList && (
        <Grid container justifyContent={"end"} marginTop='0.5%'>
          <Grid item>
            <Pagination
              count={pageCount}
              onChange={onPageClickhandler}
              disabled={pageCount === 1}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FeedBackListing;
